import React from "react";
import BackButton from "../components/BackButton";
import VideoFrame from "../assets/video_frame.png";
import ButtonList from "../components/ButtonList";
import { useParams, useNavigate } from "react-router-dom";

const Video = ({ videoData }) => {
  const { id } = useParams();
  const navigate = useNavigate();
  return (
    <div className="d-flex justify-content-center align-items-center h-100 w-100 position-relative">
      <BackButton onClickHandler={()=>{navigate("/")}}/>
      <div className="col-4 d-flex align-items-center h-100">
        <ButtonList
          items={videoData.map((videoTitlePair) => videoTitlePair.title)}
          screen={"video"}
          selectedId={parseInt(id)}
        />
      </div>
      <div className="col-8 video-frame-container">
        <img src={VideoFrame} className="video-frame" />
        <video
          className="isuzu-video"
          src={`/assets/videos/${videoData[parseInt(id) - 1].video}.mp4`}
          autoPlay
        ></video>
      </div>
    </div>
  );
};

export default Video;
